import { FeathersModel } from './feathersModel'
import { Message } from '../features/messaging/message'
import { User } from './user'
import { AssistanceFeedbackMessage } from './AssistanceFeedbackMessage'

export enum PrivateMessageQueryType {
  direct = 'onlyDirect',
  feedback = 'onlyFeedback',
  countUnread = 'countUnread',
}

export enum PrivateMessageTypeHumanized {
  direct = '',
  assistantFeedback = 'Zpětná vazba',
}

export class PrivateMessage extends FeathersModel implements Message {
  static serviceName = 'private-messages'

  userId: number
  publishedByUser: User

  parentMessageId: number
  parentMessage: PrivateMessage

  recipientId: number
  recipient: User

  title: string
  content: string
  publishedAt: Date

  attachmentUri: string

  isSelected = false

  type: PrivateMessageTypeHumanized = PrivateMessageTypeHumanized.direct

  assistance_feedback_message?: AssistanceFeedbackMessage
  user?: User

  isRead: boolean = false
  isFeedback: boolean

  updateFromProps(props): this {
    super.updateFromProps(props)
    if (this.publishedByUser) this.userId = this.publishedByUser.id
    if (this.recipient) this.recipientId = this.recipient.id
    if (this.parentMessage) this.parentMessageId = this.parentMessage.id
    if (this.publishedAt) this.publishedAt = new Date(this.publishedAt)

    if (this.assistance_feedback_message) this.type = PrivateMessageTypeHumanized.assistantFeedback
    return this
  }

  turnSubresourcesIntoFrontendModels() {
    if (this.userId) this.publishedByUser = User.createFromProps(User, this.user)
    if (this.recipientId) this.recipient = User.createFromProps(User, this.recipient)
    if (this.parentMessageId) this.parentMessage = PrivateMessage.createFromProps(PrivateMessage, this.parentMessage)
  }
}
